var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pf-medium half-vip-btn",class:{'half-vip-btn-red':_vm.h_btn_color},domProps:{"innerHTML":_vm._s(_vm.formatHtmlBtnstr())},on:{"click":_vm.clickPay}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783d0c32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@kkmh/pays/src/components/viphalfscreen/comp/PayButton.vue
// module id = null
// module chunks = 